<template>
  <span class="d-book-comments-count label label-sm label-round">
    <DuiIconBalloon />
    <span class="space-left-1em valign-middle">{{ bookCommentsCount }}</span>
  </span>
</template>

<script>
import Vue from 'vue';

import commentsService from '@d-services/comments-service/comments-service';
import { getErrorMessage } from '@d-shared/utils/errors';

export default {
  props: {
    bookSlug: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    bookCommentsCount: 0,
  }),
  mounted() {
    this.loadBookCommentsCount();
  },
  methods: {
    async loadBookCommentsCount() {
      try {
        const bookCommentsCount = await commentsService.getBookCommentsCount(this.bookSlug);
        this.$set(this, 'bookCommentsCount', bookCommentsCount);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }
    },
  },
};
</script>
